import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Location from 'invite-sign/models/location';

export default class GdprConfiguration extends Model {
  declare [Type]: 'gdpr-configuration';

  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<Location>;

  @attr('boolean') declare enabled: boolean;
  @attr('string') declare optOutVisitorProtocol: string;
  @attr('boolean') declare optOutVisitorProtocolEnabled: string;

  @attr('string') declare policyDisclosure: string;
  @attr('boolean') declare policyDisclosureEnabled: boolean;
  @attr('boolean') declare visitorConsentEnabled: boolean;
}
